import { useState } from 'react';
import { useAuth } from './useAuth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const useAccountDeletion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const deleteAccount = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      await axios.delete('/api/users/account');
      
      // 退会成功後、ログアウト処理
      await logout();
      
      // 退会完了ページへリダイレクト
      navigate('/account-deleted', { replace: true });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const errorMessage = err.response?.data?.error?.message || '退会処理に失敗しました';
        setError(errorMessage);
      } else {
        setError('予期しないエラーが発生しました');
      }
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    deleteAccount,
    isLoading,
    error,
  };
};
